/**
 * #40 · Módulo de etiquetas. Contrato en `routes/module.ts`.
 *
 * `minimumRole: 'analyst'` — es el mismo `minRole` que declara `nav.ts`. Un
 * `viewer` no ve el módulo en el menú y tampoco entra pegando la URL: las
 * lecturas de la API son de `viewer`, pero todo lo que se hace acá (mover un
 * rollo, generar códigos, denunciar un robo) es de `analyst` o de `admin`, y
 * una pantalla donde no se puede hacer nada es una pantalla que confunde.
 *
 * `orders/:orderId`, `rolls` y `units` no se solapan: los tres segmentos
 * estáticos van antes que cualquier parámetro.
 *
 * `orders/:orderId` queda montada para todos aunque la marca ya no llegue por
 * ningún enlace: quien tenga el link viejo de una orden que sí es suya —las
 * que existían antes de #142— tiene que poder abrirlo.
 */
import type { ModuleRoutes } from '../module';
import { LabelDetailPage } from './LabelDetailPage';
import { LabelOrderDetailPage } from './LabelOrderDetailPage';
import { LabelsIndexPage } from './LabelsIndexPage';
import { LabelUnitsPage } from './LabelUnitsPage';
import { LabelsStockPage } from './LabelsStockPage';
import { RollDetailPage } from './RollDetailPage';
import { RollsPage } from './RollsPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'labels',
  minimumRole: 'analyst',
  routes: [
    // El índice decide por tenant: Órdenes para el back-office, Pedidos para
    // una marca (#142). Ver `LabelsIndexPage.tsx`.
    { path: '', element: <LabelsIndexPage /> },
    { path: 'orders/:orderId', element: <LabelOrderDetailPage /> },
    { path: 'rolls', element: <RollsPage /> },
    { path: 'rolls/:rollId', element: <RollDetailPage /> },
    // Sólo el back-office la ve en las pestañas; a una marca que pegue la URL
    // le da "no existe" (#170). Antes vivía en `/hq/stock`.
    { path: 'stock', element: <LabelsStockPage /> },
    { path: 'units', element: <LabelUnitsPage /> },
    // `:code` es el CÓDIGO IMPRESO, nunca el `unit_id`: es regla de dominio
    // (#89). El id interno va ofuscado con Feistel para que el orden y el
    // volumen de serialización de la marca no se filtren, y una URL lo deja
    // además en el historial del navegador y en el log del proxy.
    { path: 'units/:code', element: <LabelDetailPage /> },
  ],
};
